import script from "./ServersView.vue?vue&type=script&setup=true&lang=js"
export * from "./ServersView.vue?vue&type=script&setup=true&lang=js"

import "./ServersView.vue?vue&type=style&index=0&id=2e0ac612&lang=css"

const __exports__ = script;

export default __exports__